// extracted by mini-css-extract-plugin
module.exports = {"centerChildren":"main-container_centerChildren__FwBZd","mainContent":"main-container_mainContent__2ClgU"};